export default {"src":"/_next/static/media/sparkle.775507bd.svg","height":56,"width":72,"blurWidth":0,"blurHeight":0};